var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-date-warning"},[_c('v-flex',{staticClass:"vf fl aic",attrs:{"xs10":"","offset-xs1":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"white","size":"18"}},[_vm._v("lock")]),_c('p',[_vm._v("Attentie! Op dit moment draait de schade verwerking. U kunt geen mutaties op verzuimen invoeren.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }